import React from "react";
import { Card, CardHeader } from "@opendate-app/setlist";
import DetailField from "./DetailField";
import { formatMonthYear } from "../../ClassesShared/classLabels";
import { useRegistrationPageContext } from "./RegistrationPageContext";
import "../../ClassesShared/classesShared.css";

export default function LearnerDetailsCard() {
  const { registration } = useRegistrationPageContext();
  const { dashboard } = registration;
  const others = dashboard.other_registrations;

  return (
    <Card header={<CardHeader title="Learner Details" />}>
      <dl className="row mb-0">
        <DetailField label="Name">{registration.full_name}</DetailField>
        <DetailField label="Email">{registration.email}</DetailField>
        <DetailField label="Phone">{registration.phone}</DetailField>
        <DetailField label="Fan since">{formatMonthYear(dashboard.fan_since, dashboard.time_zone)}</DetailField>
        {registration.note_to_instructor && <DetailField label="Note to instructor" wide>{registration.note_to_instructor}</DetailField>}
        {registration.status === "canceled" && <DetailField label="Cancellation reason" wide>{registration.cancellation_reason}</DetailField>}
        <DetailField label="Other class registrations" wide>
          {others.length > 0 && (
            <ul className="list-unstyled mb-0" data-testid="other-registrations">
              {others.map((other) => (
                <li key={other.id}>
                  <a href={other.path}>{other.class_name}</a>
                  <span className="classes-text-secondary">{` · ${other.status_label}`}</span>
                </li>
              ))}
            </ul>
          )}
        </DetailField>
      </dl>
    </Card>
  );
}
